/**
 * Container - Consistent max-width container
 */

import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface ContainerProps {
  children: ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  center?: boolean;
}

const sizeMap = {
  sm: 'max-w-2xl',
  md: 'max-w-4xl',
  lg: 'max-w-5xl',
  xl: 'max-w-6xl',
  '2xl': 'max-w-7xl',
  full: 'max-w-[var(--landing-max-width)]',
};

export function Container({ children, className, size = 'xl', center = false }: ContainerProps) {
  return (
    <div className={cn(sizeMap[size], center && 'mx-auto', className)}>
      {children}
    </div>
  );
}

